import React from "react";
import BONDHoldingsTable from "../../components/HoldingsTable/BONDHoldingsTable";
import HoldingsErrorDialog from "../../components/HoldingsTable/HoldingsErrorDialog";
import AppLoader from "../../components/AppLoader/AppLoader";
import { useUserHoldingsFetch } from "./useUserHoldingsFetch";

interface Bond {
  id: number;
  isin: string;
  quantity: number;
  price: number;
  amount: number;
  settelmentAmount: number;
  settelmentDate: string;
  yeild: number;
}

const BONDHoldings: React.FC = () => {
  const {
    loader,
    errorMessage,
    setErrorMessage,
    data: BOND,
    pageSize,
    totalPages,
    currentPage,
    handlePageChange,
    handlePageSizeChange,
    fetchHoldings,
  } = useUserHoldingsFetch<Bond>("BOND", "Failed to load bond holdings.");

  return (
    <>
      <AppLoader loading={loader} />
      <BONDHoldingsTable
        data={BOND}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        fetchData={fetchHoldings}
      />
      <HoldingsErrorDialog
        open={Boolean(errorMessage)}
        message={errorMessage}
        title="Unable to load bond holdings"
        onClose={() => setErrorMessage(null)}
      />
    </>
  );
};

export default BONDHoldings;
